import { render, staticRenderFns } from "./PurgeAllRejectedGlyphsModal.vue?vue&type=template&id=1af1209e&"
import script from "./PurgeAllRejectedGlyphsModal.vue?vue&type=script&lang=js&"
export * from "./PurgeAllRejectedGlyphsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports